import { LegacyAnchor, useFilterPermittedItems } from '@common';
import { Flex } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { NavigationLinkButton } from './components';
import { navigationLinks } from './data';
import styles from './NavigationLink.module.css';

export const NavigationLinks: React.FC = () => {
  const { filterPermittedItems } = useFilterPermittedItems();

  const permittedNavigationLinks = filterPermittedItems(navigationLinks);

  return (
    <Flex direction="column" p="xs">
      {permittedNavigationLinks.map(
        ({ path, labelKey, icon, useLegacyAnchor, legacyPath }) =>
          useLegacyAnchor ? (
            <LegacyAnchor
              key={path}
              href={legacyPath}
              className={styles.navigationLink}
            >
              <NavigationLinkButton icon={icon} labelKey={labelKey} />
            </LegacyAnchor>
          ) : (
            <Link
              key={path}
              to={path}
              activeProps={{
                style: {
                  backgroundColor: 'var(--mantine-color-layout-11)',
                },
              }}
              className={styles.navigationLink}
            >
              <NavigationLinkButton icon={icon} labelKey={labelKey} />
            </Link>
          )
      )}
    </Flex>
  );
};
